import apiEndPoints from '../utils/ctxUtil';
import { adalApiFetch } from '../adalConfig';

export function ruleProductListHasErrored(bool) {
  return {
    type: 'RULE_PRODUCT_LIST_HAS_ERRORED',
    hasErrored: bool,
  };
}

export function ruleProductListIsLoading(bool) {
  return {
    type: 'RULE_PRODUCT_LIST_IS_LOADING',
    isLoading: bool,
  };
}

export function ruleProductListFetchDataSuccess(items) {
  return {
    type: 'RULE_PRODUCT_LIST_FETCH_DATA_SUCCESS',
    items,
  };
}

export function newRuleProductSaveSuccess(bool, items) {
  return {
    type: 'NEW_RULE_PRODUCT_SAVE_SUCCESS',
    isSavedSuccess: bool,
    items: items,
  };
}

export function newRuleProductSaveErrored(bool, message) {
  return {
    type: 'NEW_RULE_PRODUCT_SAVE_ERRORED',
    isSaveErrored: bool,
    message: message,
  };
}

export function newRuleProductIsSaving(bool) {
  return {
    type: 'NEW_RULE_PRODUCT_IS_SAVING',
    isSaving: bool,
  };
}

export function deleteRuleProductHasErrored(bool) {
  return {
    type: 'DELETE_RULE_PRODUCT_HAS_ERRORED',
    hasErrored: bool,
  };
}

export function deleteRuleProductIsLoading(bool) {
  return {
    type: 'DELETE_RULE_PRODUCT_IS_LOADING',
    isLoading: bool,
  };
}

export function deleteRuleProductSuccess(offerDetails) {
  return {
    type: 'DELETE_RULE_PRODUCT_SUCCESS',
    offerDetails,
  };
}

export function ruleProductsListFetchData(ruleId) {
  const url = apiEndPoints.OFFER_RULE_PRODUCTS.replace('ruleId', ruleId);

  return (dispatch) => {
    dispatch(ruleProductListIsLoading(true));

    adalApiFetch(fetch, url, {})
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(ruleProductListIsLoading(false));

        return response;
      })
      .then((response) => response.json())
      .then((items) => dispatch(ruleProductListFetchDataSuccess(items)))
      .catch(() => dispatch(ruleProductListHasErrored(true)));
  };
}

// export function addNewRuleProductData(ruleId) {
//     const url= apiEndPoints.OFFER_RULE_PRODUCTS.replace("ruleId",ruleId);

//     return (dispatch) => {
//         dispatch(ruleProductListIsLoading(true));

//         fetch(url)
//             .then((response) => {
//                 if (!response.ok) {
//                     throw Error(response.statusText);
//                 }

//                 dispatch(ruleProductListIsLoading(false));

//                 return response;
//             })
//             .then((response) => response.json())
//             .then((items) => dispatch(ruleProductListFetchDataSuccess(items)))
//             .catch(() => dispatch(ruleProductListHasErrored(true)));
//     };
// }

export function addNewRuleProductData(ruleId, productCode) {
  let url = apiEndPoints.OFFER_RULE_PRODUCT_ADD.replace('ruleId', ruleId);
  url = url + '?productCode=' + productCode;
  return (dispatch) => {
    dispatch(newRuleProductIsSaving(true));

    adalApiFetch(fetch, url, {
      method: 'POST', // or "PUT"
      mode: 'cors',
      cache: 'no-cache',
      body: JSON.stringify(productCode),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        dispatch(newRuleProductIsSaving(false));
        if (!response.ok) {
          response.json().then(function (error) {
            dispatch(newRuleProductSaveErrored(true, error.message));
          });
          throw Error(response.status);
        }
        return response;
      })
      .then((response) => response.json())
      .then(dispatch(newRuleProductSaveSuccess(true)))
      .catch((response) => {
        // eslint-disable-next-line no-console
        console.log(response);
      });
  };
}

export function removeRuleProductData(ruleId, productCode) {
  let url = apiEndPoints.OFFER_RULE_PRODUCT_DELETE.replace('ruleId', ruleId);
  url = url + '?productCode=' + productCode;
  return (dispatch) => {
    dispatch(deleteRuleProductIsLoading(true));

    adalApiFetch(fetch, url, {
      method: 'DELETE', // or "PUT"
      mode: 'cors',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        dispatch(deleteRuleProductIsLoading(false));
        if (!response.ok) {
          throw Error(response.statusText);
        }

        return response;
      })
      //.then((response) => response.json())
      .then((ruleId) => dispatch(deleteRuleProductSuccess(ruleId)))
      .catch(() => dispatch(deleteRuleProductHasErrored(true)));
  };
}
